var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-view"},[(_vm.edit)?_c('span',[_c('PhotoEdit'),_c('PhotoList')],1):_c('span',[_c('PhotoSingle')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }